import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';

export default class MasonryGrid {
    constructor() {
        this.grid = $('.js-masonry-grid');
        if (!this.grid.length) return;

        this.init();
    }

    _bridgetToJquery() {
        jQueryBridget('masonry', Masonry, $);
        jQueryBridget('imagesLoaded', imagesLoaded, $);
    }

    _buildGrid = () => {
        this.grid = this.grid.masonry({
            itemSelector: '.masonry-grid__item',
            horizontalOrder: true
        });
    }

    init() {
        this._bridgetToJquery();

        this.grid.imagesLoaded(this._buildGrid);
    }
}



// WEBPACK FOOTER //
// ./components/masonryGrid.js